var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MhRouterView',{staticClass:"HomeView view hSpace hSpace--app",attrs:{"isContentReady":_vm.isContentReady}},[_c('div',{staticClass:"HomeView__inner view__inner"},[_c('iframe',{attrs:{"src":_vm.mapUrl,"allowtransparency":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }